module.exports = __webpack_public_path__ + "static/media/power-100.9086ae2d.svg";